import { borderosMenu } from './borderos/menu.js';

const menuAutorizadorFinanceiro = {
    label: 'Autorizador Financeiro',
    items: [borderosMenu],
    rules: [...borderosMenu.rules],
};

export { menuAutorizadorFinanceiro };
